var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450.83,
    height: 465.69,
    viewBox: "0 0 450.83 465.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2d616e;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-width:0px;}.cls-2{fill:#568a96;}.cls-3{fill:#167a9a;}.cls-4{fill:#acbbbf;}.cls-5{fill:#afd1d2;}.cls-6{fill:#2f8c9b;}.cls-7{fill:#e5efee;}.cls-8{fill:#f7941d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 226.18,
    cy: 429.81,
    rx: 222.91,
    ry: 32.24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m103.34,395.37h97.12c1.09,0,1.97.88,1.97,1.97v18.61h-101.06v-18.61c0-1.09.88-1.97,1.97-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m111.84,383.81h80c.98,0,1.78.8,1.78,1.78v9.84h-83.56v-9.84c0-.98.8-1.78,1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.54,384h-47.06v-47.05h47.06v47.05Zm-42.06-5h37.06v-37.05h-37.06v37.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.91,
    y: 331.07,
    width: 5,
    height: 58.22,
    transform: "translate(-209.21 209.83) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.51,299.75h-47.05v-47.06h47.05v47.06Zm-42.05-5h37.05v-37.06h-37.05v37.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.88,
    y: 246.82,
    width: 5,
    height: 58.22,
    transform: "translate(-150.1 185.58) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.33,173.29h-47.06v-47.06h47.06v47.06Zm-42.06-5h37.06v-37.06h-37.06v37.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.7,
    y: 120.37,
    width: 5,
    height: 58.22,
    transform: "translate(-61.41 149.09) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.31,131.1h-47.06v-47.05h47.06v47.05Zm-42.06-5h37.06v-37.05h-37.06v37.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.68,
    y: 78.18,
    width: 5,
    height: 58.22,
    transform: "translate(-31.81 136.94) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.32 89.01 128.26 89.01 128.26 44.45 133.26 44.45 133.26 84.01 170.32 84.01 170.32 44.45 175.32 44.45 175.32 89.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.26,89.01h-47.05v-47.06h47.05v47.06Zm-42.05-5h37.05v-37.06h-37.05v37.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 106.64,
    y: 36.08,
    width: 5,
    height: 58.22,
    transform: "translate(-14.36 95.33) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m259.37,88.95h-47.05v-47.05h47.05v47.05Zm-42.05-5h37.05v-37.05h-37.05v37.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 232.75,
    y: 36.02,
    width: 5,
    height: 58.22,
    transform: "translate(21.94 183.81) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m217.32,88.95h-47.06v-47.05h47.06v47.05Zm-42.06-5h37.06v-37.05h-37.06v37.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.69,
    y: 36.02,
    width: 5,
    height: 58.22,
    transform: "translate(9.85 154.3) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "383.09 89.01 338.54 89.01 338.54 44.45 343.54 44.45 343.54 84.01 383.09 84.01 383.09 89.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 359,
    y: 35.95,
    width: 5,
    height: 57.59,
    transform: "translate(54.26 265.95) rotate(-43.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m343.54,89.01h-47.05v-47.06h47.05v47.06Zm-42.05-5h37.05v-37.06h-37.05v37.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 316.91,
    y: 36.08,
    width: 5,
    height: 58.22,
    transform: "translate(46.11 242.89) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.4 89.02 43.01 88.73 43.04 83.73 86.4 83.99 86.4 44.45 91.4 44.45 91.4 89.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.34,
    y: 62.15,
    width: 60.26,
    height: 5,
    transform: "translate(-26.26 64.26) rotate(-43.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m42.99,88.51h85.13v9H43.8c-.44,0-.8-.36-.8-.8v-8.2h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.32,
    y: 2.51,
    width: 5,
    height: 42.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149.39,
    y: -1.26,
    width: 5,
    height: 92.79,
    transform: "translate(-4.04 73.31) rotate(-26.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 235.27,
    y: -82.2,
    width: 5,
    height: 213.7,
    transform: "translate(169.78 253.82) rotate(-79.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m175.12,89.02h207.96v8.2c0,.44-.36.8-.8.8h-207.16v-9h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 317.62,
    y: 86.28,
    width: 5,
    height: 55.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.44,257.76h-47.05v-47.06h47.05v47.06Zm-42.05-5h37.05v-37.06h-37.05v37.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.82,
    y: 204.83,
    width: 5,
    height: 58.22,
    transform: "translate(-120.66 173.46) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.41,215.57h-47.06v-47.05h47.06v47.05Zm-42.06-5h37.06v-37.05h-37.06v37.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.79,
    y: 162.64,
    width: 5,
    height: 58.22,
    transform: "translate(-91.06 161.31) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 175.08,
    y: 88.65,
    width: 41.61,
    height: 41.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m301.42,88.95h-47.05v-47.05h47.05v47.05Zm-42.05-5h37.05v-37.05h-37.05v37.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 274.8,
    y: 36.03,
    width: 5,
    height: 58.22,
    transform: "translate(34.03 213.32) rotate(-44.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 307.41,
    y: 139.07,
    width: 24.33,
    height: 17.01,
    rx: 1.92,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.01,
    y: 183.72,
    width: 53.15,
    height: 5,
    transform: "translate(-43.64 267.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 337.35,
    y: 159.65,
    width: 5,
    height: 53.15,
    transform: "translate(-32.14 294.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m175.54,341.83h-47.06v-47.06h47.06v47.06Zm-42.06-5h37.06v-37.06h-37.06v37.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.91,
    y: 288.91,
    width: 5,
    height: 58.22,
    transform: "translate(-179.62 197.7) rotate(-44.57)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m368.14,199.71h-99.17c-4.4,0-7.97,3.58-7.97,7.97v160.52c0,4.4,3.58,7.97,7.97,7.97h121.32c4.4,0,7.97-3.58,7.97-7.95l.94-138.08v-1.54s-31.07-28.9-31.07-28.9Zm22.15,169.49h-121.32c-.55,0-.99-.44-.99-.99v-160.52c0-.55.45-.99.99-.99h95.54v22.7c0,1.87,1.51,3.38,3.38,3.38h24.31l-.92,135.43c0,.55-.45.99-.99.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280.4,
    y: 227.95,
    width: 69.1,
    height: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280.36,
    y: 246.74,
    width: 99.6,
    height: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280.31,
    y: 265.47,
    width: 99.6,
    height: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280.43,
    y: 284.09,
    width: 99.6,
    height: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280.38,
    y: 302.82,
    width: 99.6,
    height: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280.19,
    y: 321.43,
    width: 99.6,
    height: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280.15,
    y: 340.17,
    width: 99.6,
    height: 8.65
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 313.3,
    y: 149.31,
    width: 13.18,
    height: 27.08,
    rx: 6.11,
    ry: 6.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionIllustration);
export default __webpack_public_path__ + "static/media/Construction_illustration.b0369d83e89b85e1c894e193585d769d.svg";
export { ForwardRef as ReactComponent };